import type { Driver } from "../adamo/types";
import { operatorId } from "../state/operatorId";

export function DriverBadge({ driver, onClaim, onRelease }: {
  driver: Driver; onClaim: () => void; onRelease: () => void;
}) {
  const mine = driver?.lease_ok && driver.operator_id === operatorId();
  if (mine) {
    return (
      <div className="row">
        <span className="k">you are driving</span>
        <button onClick={onRelease}>Let go</button>
      </div>
    );
  }
  if (driver?.lease_ok) {
    return (
      <div className="row">
        <span className="k">driven by {driver.display_name || "someone else"}</span>
        <button className="warn" onClick={onClaim}>Take over</button>
      </div>
    );
  }
  return (
    <div className="row">
      <span className="k">nobody is driving</span>
      <button onClick={onClaim}>Take the controls</button>
    </div>
  );
}
